import { add, listen, qs } from "@fluorescent/dom";
import { syncTabIndexesOnFlickity } from "@/lib/a11y";

export default (node, opts = {}) => {
  const previousButton = qs("[data-prev]", node);
  const nextButton = qs("[data-next]", node);

  let slider;

  const io = new IntersectionObserver(
    ([{ isIntersecting: visible }]) => {
      if (slider && visible && (slider.slides || {}).length > 1) {
        add(nextButton, "visible");
        io.unobserve(node);
      }
    },
    { threshold: 0.75 }
  );

  io.observe(node);

  function change() {
    add(previousButton, "visible");
    syncTabIndexesOnFlickity(slider);
  }

  const prevClick = listen(previousButton, "click", () => slider.previous());
  const nextClick = listen(nextButton, "click", () => slider.next());

  import(flu.chunks.flickity).then(({ Flickity }) => {
    slider = new Flickity(node, {
      adaptiveHeight: true,
      cellAlign: "left",
      cellSelector: "[data-slide]",
      pageDots: false,
      prevNextButtons: false,
      watchCSS: true,
      wrapAround: true,
      on: {
        ready: function () {
          var flkty = Flickity.data(node); // This is a pain but we can't access the instance within here
          syncTabIndexesOnFlickity(flkty);
        },
      },
      ...opts,
    });
    slider.on("change", change);
  });

  return {
    destroy: () => {
      if (slider && (slider.slides || {}).length > 1) {
        prevClick();
        nextClick();
      }
      io.disconnect();
      slider && slider.destroy();
    },
    select: index => slider && slider.select(index),
  };
};
